var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDashboards = function SvgDashboards(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 81"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m50.243 27.244 9.25-6.912 1.36 11.466-4.386-1.882-9.594 22.353a1 1 0 0 1-1.842-.01L36.598 31.98l-5.635 14.09a1 1 0 0 1-1.54.42l-7.965-6.14-3.064 14.784a1 1 0 0 1-1.959-.406l3.388-16.348a1 1 0 0 1 1.59-.59l8.184 6.309 6.055-15.138a1 1 0 0 1 1.852-.012l8.465 20.356 8.66-20.178z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M68.61 17.31a4 4 0 0 0-3.987-3.673H12.284a4 4 0 0 0-4 4v39.99a4 4 0 0 0 3.675 3.986 4 4 0 0 0 3.986 3.674h52.34a4 4 0 0 0 4-4v-39.99a4 4 0 0 0-3.675-3.986m-3.987 42.316a2 2 0 0 0 2-2v-39.99q0-.168-.027-.329l-.002-.01a2 2 0 0 0-1.971-1.66H12.284a2 2 0 0 0-2 2v39.99a2 2 0 0 0 2 2zm-48.678 3.662a2 2 0 0 1-1.971-1.662h50.649a4 4 0 0 0 4-4v-38.3a2 2 0 0 1 1.661 1.972v39.99a2 2 0 0 1-2 2z",
    clipRule: "evenodd"
  })));
};
export default SvgDashboards;